// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2MPT9","icon":"SortAdornment_icon__2i4mz","up":"SortAdornment_up__25fNv","down":"SortAdornment_down__1-Eyd","active":"SortAdornment_active__wsj1a"};